<template>
  <div>
    <el-form
      size="mini"
      label-width="200px"
      v-loading="loading"
    >
      <div v-for="(item, index) in pageInfo" :key="index">
        <PageList
          :page="item.column"
          :pageId="pageId"
          :change.sync="item.value"
          :reset="resetNum"
          :checkReq.sync="item.req"
        >
        </PageList>
      </div>

      <el-form-item>
        <el-button type="primary" @click="submitForm">{{
          $t("message.button.createNow")
        }}</el-button>
        <el-button @click="reset">{{ $t("message.button.reset") }}</el-button>
        <slot></slot>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import PageList from "./pageList.vue";
export default {
  data() {
    return {
      createForm: false,
      pageInfo: [],
      columnOne: {},
      pageId: {},
      pageData: [],
      resetNum: 0,
      typeName:'',

      loading: true,
      create_list: [],
      multiList: [],

      input_width: {
        width: "50%",
      },
    };
  },
  components: {
    PageList,
  },
  methods: {
    selectType() {
      this.$forceUpdate();
    },
    getMultiList(obj) {
      let arr = [];
      obj.uiTypes.map((i, e) => {
        if (i == 4) {
          return arr.push(obj.ids[e]);
        }
      });
      return arr;
    },
    submitForm(){
      const req = this.pageInfo.map(i => i.req);
      let m = this.pageInfo.map((i) => i.value);
      for (const key in req) {
        if (!req[key]  && req[key] != undefined) {
          this.$message.error(this.$t('message.warning.required'))
          return
        }
      }
      
      let obj = {};
      obj.pageOne = Object.assign(m[0], { classId: this.pageId.clsId });
      obj.pageTwo = m[1];
      obj.pageThree = m[2];

      obj.objectId = {
        classId: this.pageId.clsId,
        subClassId: this.pageId.id,
        id: "",
      };
      this.submit(obj);
    },
    // submitForm() {
    //   //获取multilist列表项
    //   let arr = this.pageInfo.map((i) => {
    //     // return (arr = arr.concat(this.getMultiList(i.column.object.columnInfo)));
    //     return {
    //       multiList: this.getMultiList(i.column.object.columnInfo),
    //       reqList: this.getReqList(i.column.object.columnInfo),
    //     };
    //   });
    //   console.log("arr", arr);

    //   //对pageInfo进行深拷贝
    //   let m = JSON.parse(JSON.stringify(this.pageInfo.map((i) => i.val)));
    //   console.log(m);
    //   m.map((i, e) => {
    //     let list = Object.keys(i);
    //     //将multilist的数据格式由数组转化为‘；’间隔的字符串
    //     list.forEach((j) => {
    //       //此时的 j 是字符串，需要转化为数字类型
    //       if (arr[e].multiList.includes(parseInt(j))) {
    //         i[j] = i[j].join(";") || "";
    //       }
    //       if (i[j] == "") {
    //         this.$message.error(this.$t("message.warning.required"));
    //         return;
    //       }
    //     });
    //   });
    //   //检查必填项是否完全填写  **map()无法终止遍历
    //   for (const i in m) {
    //     if (Object.keys(m[i]).length < arr[i].reqList.length) {
    //       this.$message.error(this.$t("message.warning.required"));
    //       return false;
    //     }
    //   }
    //   let obj = {};
    //   obj.pageOne = Object.assign(m[0], { classId: this.pageId.clsId });
    //   obj.pageTwo = m[1];
    //   obj.pageThree = m[2];

    //   obj.objectId = {
    //     classId: this.pageId.clsId,
    //     subClassId: this.pageId.id,
    //     id: "",
    //   };
    //   this.submit(obj);
    // },
    submit(obj) {
      axios.post("/pmdm/manufacturers/saveManufacturerP1P2P3", obj).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          // this.$router.push("/titleBlock");
          this.$emit('getMFid',res.data.object)
          
        }
      });
    },
    reset() {
      this.resetNum++;
    },

    async getManuFactData() {
      
      const { data: res } = await this.$http.get(
        "/pmdm/admin/cls/getClsesWithSubClses?baseClsId=105"
      );
      this.pageId = res.object.clses[0].children[0];
      console.log(this.pageId);
      
      const { data: columnOne } = await axios.get(
        "/pmdm/admin/getVisibleTableColumnInfo/" + 1050101 + "/1"
      );
      const { data: columnTwo } = await axios.get(
        "/pmdm/admin/getVisibleTableColumnInfo/" + 1050101 + "/2"
      );
      const { data: columnThree } = await axios.get(
        "/pmdm/admin/getVisibleTableColumnInfo/" + 1050101 + "/3"
      );
      this.pageInfo = [
        { column: columnOne, val: {} },
        { column: columnTwo, val: {} },
        { column: columnThree, val: {} },
      ];
      this.loading = false;
    },

  },
  created() {
    this.getManuFactData();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
};
</script>

<style></style>
